<!-- TEMPLATE -->
<template>
  <div :class='serviceListClass'>
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns services-list'>
        <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>{{title}}</span>
            </span>
        </dean-section-title>
        <dean-notification></dean-notification>
        <dean-table
            :data='serviceData'
            :columns='columns'
            @column-click='columnClick'
        >
          <span slot="status" slot-scope="status">
              <dean-icon v-for="statusIcon in status.value.content"
                         :key="statusIcon.id"
                         className="serviceIcon"
                         :glyph="statusIcon"
                         width="25"
                         height="25"
                         title="Service">
              </dean-icon>
            </span>
        </dean-table>
        <dean-pagination
            :current-page='serviceMetaData.pageNumber'
            :total-items='serviceMetaData.totalResults'
            :items-per-page='serviceMetaData.itemsPerPage'
            :select-items-per-page='selectItemsPerPage'
            :visible-pages='serviceMetaData.visiblePages'
            @page-changed='paginationChanged'
            @items-per-page='itemsPerPageChanged'
        >
        </dean-pagination>
        <transition name="fade" mode="out-in" v-if="isLoading">
          <dean-load-overlay class="table-overlay"></dean-load-overlay>
        </transition>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
  // VUE
  import {
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';
  import sideMenuCustomerMixin from '@/mixins/sideMenuCustomerMixin';
  import {statusStringToIcons} from '@/mixins/stringToIcons';
  import {getPhoneNumberFromAdditionalData} from '@/mixins/additionalDataPhoneNumber';
  import {CollapseTransition} from 'vue2-transitions';

  import {
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    deanLoadOverlay,
  } from '@deanone/dean-components';
  import deanNotification from '@/components/deanComponents/deanNotification.vue';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      deanIcon,
      deanNotification,
      deanLoadOverlay,
      CollapseTransition,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuCustomerMixin) {

    public showSomething: boolean = false;
    public data: object[] = [];
    public isLoading: boolean = false;
    public title: string = 'Dienst';
    public currencyFormatter = new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'});

    // COMPUTED
    get serviceListClass() {
      let value = 'service-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get serviceMetaData() { // TODO no meta data is send yet
      return this.pageMeta;
    }

    get serviceData() {
      return this.data;
    }

    public meta: object = {};

    public columns: any = {
      name: {
        content: 'Productnaam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      amount: {
        content: 'Aantal',
        align: 'left',
        sort: true,
        dql: 'productCount',
      },
      connectAmount: {
        content: 'Aansluitkosten',
        align: 'left',
        sort: true,
        dql: 'connectAmount',
      },
      recurrentAmount: {
        content: 'Maandelijkse kosten',
        align: 'left',
        sort: true,
        dql: 'recurrentAmount',
      },
      disconnectAmount: {
        content: 'Afsluitkosten',
        align: 'left',
        sort: true,
        dql: 'shutdownAmount',
      },
      startDate: {
        content: 'Begindatum',
        align: 'left',
        sort: true,
        dql: 'startDate',
      },
      status: {
        content: 'Status',
        type: 'slot',
        slot: 'status',
        align: 'center',
        sort: false,
        dql: 'status',
      },
    };

    public tableName(): string {
      return 'customer-service-details';
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const url = '/-/trade/api/customer.services.info';

      axios.post(url, {
        customerId: this.$route.params.pid,
        serviceId: this.$route.params.serviceId,
        sort: data.sort,
        meta: {
          numberOfItems: data.itemsPerPage,
          startIndex: this.startIndex,
        },
      })
        .then(
          (response) => {
            this.title = response.data.data.serviceTrait ? 'Dienst ' + response.data.data.serviceTrait : this.title;
            this.data = [];
            for (const groupedProduct of response.data.data.groupedProducts) {
              let productName = groupedProduct.product.name;
              const phoneNumber = getPhoneNumberFromAdditionalData(groupedProduct.additionalData);

              if (phoneNumber) {
                productName += ` (${phoneNumber})`;
              }

              this.data.push({
                  name: productName,
                  amount: groupedProduct.nOfProducts,
                  connectAmount: this.currencyFormatter.format(groupedProduct.connectAmount),
                  recurrentAmount: this.currencyFormatter.format(groupedProduct.recurrentAmount),
                  disconnectAmount: this.currencyFormatter.format(groupedProduct.disconnectAmount),
                  startDate: groupedProduct.startDate,
                  status: statusStringToIcons(groupedProduct.status.icon),
                },
              );
            }

            this.updateMeta(response.data.meta);
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public created() {
      // this.setDefaultSort('trait');
      this.loadList(this.pageMeta);
      this.buildSideMenuCustomer(this.$route.params.pid);
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>

